
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/frontend-dev",
      function () {
        return require("private-next-pages/cases/frontend-dev/index.tsx");
      }
    ]);
  